import {
  BrochureCTA,
  FloatingSection,
  Header,
  Intro,
  KitchenExploreCTA,
  NewsWidget,
  PartnerTicker,
  QuickLinks,
} from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";

export default function SocialHousing() {
  return (
    <div>
      <Header
        title={t(routes.socialHousing, "title")}
        image={t(routes.socialHousing, "image")}
        bgColor="black"
        className="text-white"
      >
        <p>
          We understand the importance of supporting affordable homes. Everyone
          deserves a decent home to live in. Paula Rosa Manhattan manufactures
          and supplies kitchens tailored to meet your needs and those of your
          residents.
        </p>
      </Header>
      <Intro
        title="Our kitchens are sustainably sourced and durability tested, providing you with the assurance that they will not only remain beautiful to look at, but will stand the test of time."
        bgColor="black"
      />
      <PartnerTicker title="Some of the frameworks that we are on" />
      <FloatingSection
        className="mt-10"
        bgColor="white"
        image="media/assets/social-housing-service.jpg"
        title={
          <>
            <h3 className="text-lg font-light">Service</h3>
            <p className="font-medium">
              With our experienced nationwide team of surveyors, you are in safe
              hands.
            </p>
            <p>
              We will provide you and your residents with first-class service
              when undertaking a detailed kitchen survey, ensuring you have
              everything you need when updating your homes.{" "}
            </p>
            <p className="mb-4 border-b pb-8">
              Paula Rosa Manhattan has its own fleet and logistics team that
              delivers kitchens to your homes. Our fleet runs on HVO fuel, with
              sustainability at the forefront of our minds at all times.
            </p>
            <h3 className="text-lg font-light">Social Value</h3>
            <p className="font-medium">
              We understand the true value of supporting local communities.
            </p>
            <p>
              We would be delighted to collaborate with you and work closely on
              your local community initiatives to bring greater good to your
              neighbourhoods.
            </p>
          </>
        }
      />
      <BrochureCTA
        text="Find out more about how we work with the social sector. Including affordable housing and supported living kitchens."
        image="/media/assets/brochure-social.jpg"
        link="https://issuu.com/paularosamanhattan/docs/prmf-social-brochure?mode=window"
      />
      <KitchenExploreCTA />
      <QuickLinks />
      <NewsWidget source="/news/case-studies" tag="social" />
    </div>
  );
}
